module.exports = __webpack_public_path__ + "annualreview2018/static/img/ceo-introduction.9b02684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/ceo-introduction.png
// module id = WnL2
// module chunks = 10